export default __webpack_public_path__ + "998ed62869631be881cb907301e6e320.svg";